import React, { Component } from 'react';
import { connectDeep } from 'redux-utils';
import styled from 'styled-components';
import uuid from 'uuid/v4';

import { savePermissions } from 'actions/gallery';
import Modal, { FlexRow, RowTitle, RowsContainer } from 'components/Modal';
import { Checkbox } from 'components/Toggle';
import {
  useAbstractEditor,
  List as PermissionList,
  connect as connectPermissions
} from 'components/Permissions';

import i18n from 'i18n';

const AboveSection = styled.div`
  margin-top: 20px;
`;
const TextButton = styled.div`
  display: inline-block;
  margin: 10px 0 -10px 0;
  padding: 10px;
  ${({ theme }) => `
    color: ${theme.fitbitPink};
    font-family: ${theme.fontSemibold};
  `}
`;

class PermissionItem extends Component {
  onClick = () =>
    this.props.onChange(this.props.item.value, !this.props.checked);

  render() {
    const {
      checked,
      item: { isNew, title }
    } = this.props;
    return (
      <FlexRow data-test-id={`permission-item-${title}`} onClick={this.onClick}>
        <RowTitle bold={isNew}>{title}</RowTitle>
        <Checkbox checked={checked} />
      </FlexRow>
    );
  }
}

const PermissionModal = ({
  app,
  permissions,
  onApprove,
  onClose,
  savePermissions
}) => {
  const {
    permissions: localPermissions,
    visiblePermissions,
    setPermission,
    setAllPermissions
  } = useAbstractEditor({
    app,
    permissions,
    onEnableOsPermission: onClose
  });

  return (
    <Modal
      id={`PermissionModal-${uuid()}`}
      contentAbove={
        <AboveSection>
          <div>{i18n('component.PermissionModal.text')()}</div>
          <TextButton
            data-test-type="select-all-button"
            onClick={() => setAllPermissions(true)}
          >
            {i18n('component.PermissionModal.selectAllButtonText')()}
          </TextButton>
        </AboveSection>
      }
      contentCenter={
        <PermissionList
          containerComponent={RowsContainer}
          itemComponent={PermissionItem}
          newPermissions={app.newPermissions}
          permissions={localPermissions}
          visiblePermissions={visiblePermissions}
          onChange={setPermission}
        />
      }
      title={i18n('component.PermissionModal.title')({ appName: app.name })}
      onClose={onClose}
      buttons={[
        {
          text: i18n('component.PermissionModal.disallowButtonText')(),
          onClick: onClose,
          testType: 'cancel-button'
        },
        {
          text: i18n('component.PermissionModal.allowButtonText')(),
          onClick: () => {
            savePermissions(localPermissions);
            onApprove();
          },
          highlight: true,
          testType: 'install-button'
        }
      ]}
    />
  );
};

const mapDispatchToProps = (dispatch, { app }) => ({
  savePermissions: (grantedPermissions) =>
    dispatch(savePermissions({ appId: app.id, grantedPermissions }))
});

export default connectPermissions(
  connectDeep(null, mapDispatchToProps)(PermissionModal)
);
